module.exports = __webpack_public_path__ + "static/iplug-6c9f621d73e403bd87d8fcf06825130b.png";